import * as RTK from '@reduxjs/toolkit';
import * as Core from './core';
import { v4 as uuid } from 'uuid';

/**
 * The state is simply the conversion ID to be used this session.
 *
 * The state is set to undefined before the app initialises. After this, the app should select a
 * conversion ID either from the session storage, or generate a new one if the session storage is
 * empty.
 */
export type State = { value: string | undefined };

export const initialState: State = { value: undefined };

const slice = RTK.createSlice({
    name: 'session-id',
    initialState,
    reducers: {},
    extraReducers: builder =>
        builder.addCase(Core.initialise, (state, _action) => {
            state.value = uuid();
        }),
});

export const {} = slice.actions;

export const reducer = slice.reducer;
